"use strict";import{tag as i}from"../custom-tag.js";export function widgetIcon({height:t=16,width:e=16,hidden:r=!1,title:l="Widget"}={}){return i`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${t}
      fill="currentColor"
      viewBox="0 0 22 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M0 10.91C0 4.883 4.925 0 11 0s11 4.884 11 10.91V24H0z"
      />
    </svg>
  `}
//# sourceMappingURL=widget.js.map
